module.exports = __webpack_public_path__ + "static/media/ski-tricks.0d527b90.mov";